"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelStateEdit = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const observable_map_1 = require("../util/observable.map");
class CollectionModelStateEdit extends core_shared_1.CollectionModelStateProxy {
    constructor(state) {
        super(state);
        this.fields = new observable_map_1.ObservableIMap();
        this.geometries = new observable_map_1.ObservableIMap();
    }
    reset() {
        super.reset();
    }
    setFieldValue(fieldId, state) {
        super.setFieldValue(fieldId, state);
    }
}
exports.CollectionModelStateEdit = CollectionModelStateEdit;
tslib_1.__decorate([
    mobx_1.action
], CollectionModelStateEdit.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionModelStateEdit.prototype, "setFieldValue", null);
//# sourceMappingURL=collection.edit.model.js.map